import SearchBar from '@components/atoms/SearchBar'
import { useState } from 'react'
import { useDisclosure } from '@nextui-org/react-latest'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import dynamic from 'next/dynamic'
import styled from '@emotion/styled'

const CategoriesDropdown = dynamic(() => import('../CategoriesDropdown'))
const FiltersModal = dynamic(() => import('./components/FiltersModal'))
// const SearchBar = dynamic(() => import('@components/atoms/SearchBar'), {
//   ssr: false,
// })
export const SearchFiltersWrapper = styled.div`
  box-shadow: 0 3px 10px rgba(0 0 0/0.1);
  height: 45px;
  margin-left: 0;
  display: flex;
  align-items: center;
  border-radius: 30px;
  width: 100%;
  max-width: 100%;
  @media (min-width: 640px) {
    height: 55px;
    box-shadow: none;
    margin-left: 1rem;
  }
  @media (min-width: 768px) {
    margin-left: 2rem;
  }
  @media (min-width: 1280px) {
    margin-left: 3.1rem;
  }
`

const CategoriesButton = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: max-content;
  padding: 0 24px 0 34px;
  cursor: pointer;
  position: relative;
  @media (max-width: 1100px) {
    display: none;
  }
  &::after {
    content: '';
    position: absolute;
    height: 40%;
    width: 1px;
    right: 0;
  }
`
const SearchBarWrapper = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 12px;

  @media (max-width: 1100px) {
    max-width: calc(100%);
  }
`

type Props = {}

const SearchSection = ({}: Props) => {
  const { t } = useTranslation(['common'])
  const { isOpen, onOpen, onOpenChange } = useDisclosure()

  const [showCategoriesDropdown, setShowCategoriesDropdown] =
    useState<boolean>(false)

  const [isSearchInputInFocus, setIsSearchInputInFocus] =
    useState<boolean>(false)

  return (
    <>
      <SearchFiltersWrapper className="border border-uguGray sm:border-uguDarkGrey">
        {!isSearchInputInFocus ? (
          <CategoriesButton
            as={motion.div}
            key="category-button"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onMouseEnter={() => setShowCategoriesDropdown(true)}
            onMouseLeave={() => setShowCategoriesDropdown(false)}
            data-cy-id="category-button"
            className="font-semiBold text-uguPurple after:border-r-uguDarkGrey after:border-r-1"
          >
            {t('strings.categories', { ns: 'common' })}
            {showCategoriesDropdown && (
              <CategoriesDropdown
                key="categoriesDropdown"
                setShowCategoriesDropdown={setShowCategoriesDropdown}
              />
            )}
          </CategoriesButton>
        ) : (
          <></>
        )}

        <SearchBarWrapper
          layout
          as={motion.div}
          key="search-input"
          transition={{ duration: 0.2 }}
        >
          <SearchBar
            onFocus={() => setIsSearchInputInFocus(true)}
            onBlur={() => setIsSearchInputInFocus(false)}
            handleFilterButton={onOpen}
            placeholder={t('header.searchAnyCourse', { ns: 'common' })}
            width={'100%'}
          />
        </SearchBarWrapper>
      </SearchFiltersWrapper>
      {isOpen ? (
        <FiltersModal isOpen={isOpen} onOpenChange={onOpenChange} />
      ) : (
        <></>
      )}
    </>
  )
}

export default SearchSection
